/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./authenticate.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./authenticate.component";
import * as i3 from "@angular/router";
import * as i4 from "../login/shared/login.service";
import * as i5 from "../shared/services/staff.service";
import * as i6 from "../user-detail.service";
var styles_AuthenticateComponent = [i0.styles];
var RenderType_AuthenticateComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AuthenticateComponent, data: {} });
export { RenderType_AuthenticateComponent as RenderType_AuthenticateComponent };
export function View_AuthenticateComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_AuthenticateComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-authenticate", [], null, null, null, View_AuthenticateComponent_0, RenderType_AuthenticateComponent)), i1.ɵdid(1, 114688, null, 0, i2.AuthenticateComponent, [i3.ActivatedRoute, i3.Router, i4.LoginService, i5.StaffService, i6.DataService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AuthenticateComponentNgFactory = i1.ɵccf("app-authenticate", i2.AuthenticateComponent, View_AuthenticateComponent_Host_0, {}, {}, []);
export { AuthenticateComponentNgFactory as AuthenticateComponentNgFactory };
